function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { Icon } from '../../../components/Icon';
import { createTransition, dontForwardProps } from '../../../util';
export const StyledIcon = styled(Icon).withConfig(dontForwardProps()).withConfig({
  displayName: "StyledIcon",
  componentId: "asurion-ui-react__sc-ry4372-0"
})(["position:absolute !important;top:2px;left:2px;", " ", " svg path{", ";", "}"], ({
  fill
}) => !fill && `opacity: 0 !important;`, () => createTransition({
  properties: ['opacity']
}), ({
  fill
}) => fill && `fill: ${fill} !important;`, () => createTransition({
  properties: ['fill']
}));
export const CheckboxIcon = ({
  checked,
  hoverState,
  disabled,
  ...props
}) => {
  let fill;
  if (hoverState === 'active') {
    fill = colors.black;
  } else if (!checked) {
    fill = null;
  } else if (disabled) {
    fill = colors.neutralBrighter;
  } else {
    fill = colors.white;
  }
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({}, props, {
    fill: fill,
    "aria-hidden": "true",
    src: "checkmark-v",
    size: "normal"
  }));
};